import BaseValidator from "./BaseValidator";

export default class TextValidator extends BaseValidator {
    /**
     *
     * @param value
     * @param t - translation function
     * @return {Array}
     */
    validate(value, t = null) {
        let errors = [];
        if (typeof value !== "string") {
            let errorText = t ? t("validation.text.type", { value }) : null;
            errorText = errorText || `${value} is not a string`;
            if (errorText) {
                errors.push(errorText);
            }
        }

        return errors;
    }
}
